import { portfolioData } from '../../../mocks/portfolio';

export default function Testimonial() {
  const { testimonials } = portfolioData;
  const testimonial = testimonials[0];

  return (
    <section className="bg-white py-32">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          {/* Left Text Area */}
          <div className="lg:col-span-3">
            {/* Small Heading */}
            <div className="flex items-center gap-3 mb-12">
              <div className="w-2 h-2 bg-[#1a1a1a] rounded-full"></div>
              <span className="text-[#1a1a1a] text-sm tracking-wider uppercase font-medium">
                推薦の声
              </span>
            </div>

            {/* Quote */}
            <div className="mb-12">
              <i className="ri-double-quotes-l text-[#d4c5b9] text-5xl mb-6 block"></i>
              <p className="text-[#1a1a1a] text-4xl lg:text-5xl font-serif leading-relaxed mb-8">
                {testimonial.text}
              </p>
            </div>

            {/* Author Info */}
            <div className="flex items-center gap-4">
              <div>
                <p className="text-[#1a1a1a] text-xl font-bold">{testimonial.author}</p>
                <div className="flex items-center gap-2 mt-1">
                  <p className="text-[#666666] text-base">{testimonial.title}</p>
                  <span className="text-[#666666]">•</span>
                  <p className="text-[#666666] text-base">{testimonial.company}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Visual Area */}
          <div className="lg:col-span-2">
            <div className="relative h-full min-h-[600px]">
              <img 
                src={testimonial.image}
                alt={testimonial.author}
                className="w-full h-full object-cover object-center rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}